export function getRangeWeek(fechaReferencia = new Date()) {
  const fecha = new Date(fechaReferencia);
  const diaSemana = fecha.getDay();

  // Lunes como inicio
  const diferenciaLunes =
    fecha.getDate() - diaSemana + (diaSemana === 0 ? -6 : 1);
  const lunes = new Date(new Date(fecha).setDate(diferenciaLunes));

  const domingo = new Date(lunes);
  domingo.setDate(lunes.getDate() + 6);

  const opciones = { day: "numeric", month: "numeric" };

  return {
    start: lunes.toLocaleDateString("es-ES", opciones),
    end: domingo.toLocaleDateString("es-ES", opciones),
  };
}
